import { AxiosAdapter } from '../commons/adapters';
import { QueryPagination } from 'commons/interfaces';
import { buildQuery } from 'commons/utils/helpers';

const endPoint = '/v1/services-ia-credit-balance';
const Http = new AxiosAdapter();

export const getAllServicesIaBalance = async (query?: QueryPagination) => {
  try {
    return await Http.get<any>(`${endPoint}?${buildQuery(query)}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('getAllServicesIaBalance error', error);
  }
};

export const getServicesIaBalanceById = async (id: string) => {
  try {
    return await Http.get<any>(`${endPoint}/${id}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('getServicesIaBalanceById error', error);
  }
};
